import { render, staticRenderFns } from "./Psu.vue?vue&type=template&id=7b891ec1&scoped=true"
import script from "./Psu.vue?vue&type=script&lang=js"
export * from "./Psu.vue?vue&type=script&lang=js"
import style0 from "./Psu.vue?vue&type=style&index=0&id=7b891ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b891ec1",
  null
  
)

export default component.exports